import * as React from 'react';
import { IUser } from '../../../interfaces/IUser';
import { Helper } from '../../../Helper';
import { Environment } from '../../../services/Environment';
import { inject, observer } from 'mobx-react';
import { TeamsStore } from '../stores';
import * as styles from "./TeamsCard.css";
import DateTimeService from '../../../services/DateTimeService';
import { IAIcon } from '../../icon/Icon';
import { ConditionalOutput } from '../../../services/ConditionalOutput';

export interface ITeamsCardProps {
  teamsStore?: TeamsStore;
  id: string;
  subject?: string;
  text: string;
  author: IUser;
  date: Date;
  team: any;
  tenant: any;
  channel: any;
  reactions: number;
  replies: number;
  highlightedComments: IUser[];
}

@inject('teamsStore')
@observer
export class TeamsCard extends React.Component<ITeamsCardProps> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();

  constructor(props: ITeamsCardProps) {
    super(props);
  }

  render() {
    // let commentAuthors = "";
    // if (this.props.highlightedComments != undefined) {
    //   if (this.props.highlightedComments.length == 1) {
    //     if (this.props.replies != undefined && this.props.replies == 1) {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName} and 1 other commented this`;
    //     } else if (this.props.replies != undefined && this.props.replies > 1) {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName} and ${this.props.replies} others commented this`;
    //     } else {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName} commented this`;
    //     }
    //   } else if (this.props.highlightedComments.length == 2) {
    //     if (this.props.replies != undefined && this.props.replies == 1) {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName}, ${this.props.highlightedComments[0].displayName} and 1 other commented this`;
    //     } else if (this.props.replies != undefined && this.props.replies > 1) {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName}, ${this.props.highlightedComments[0].displayName} and ${this.props.replies} others commented this`;
    //     } else {
    //       commentAuthors = `${this.props.highlightedComments[0].displayName} and ${this.props.highlightedComments[0].displayName} commented this`;
    //     }
    //   }
    // } else {
    //   if (this.props.replies != undefined) {
    //     commentAuthors = `${this.props.replies} commented this`;
    //   }
    // }

    let text = this.props.text.replace(/style="[^"]*"/g, "");

    var div = document.createElement('div');
    div.innerHTML = text;
    var imgs = div.getElementsByTagName("img");
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].src.indexOf("graph.microsoft.com") != -1) {
        text = text.replace(imgs[i].src, `${Environment.getEnvironmentForTeamsAPI(this.props.teamsStore.environment)}/${this.props.teamsStore.tenant}/hosted-content?authToken=${this.props.teamsStore.token}&url=${encodeURIComponent(imgs[i].src)}`);
      }
    }
    let firstNameChar = this.props.author.displayName != undefined ? this.props.author.displayName.split(" ")[0].charAt(0) : "";
    let lastNameChar = this.props.author.displayName != undefined ? this.props.author.displayName.split(" ")[this.props.author.displayName.split(" ").length - 1].charAt(0) : "";
    return (
      <a href={
          new ConditionalOutput(`https://teams.microsoft.com/l/message/${this.props.channel.id}/${this.props.id}?tenantId=${this.props.tenant.id}&groupId=${this.props.team.id}&teamName=${this.props.team.displayName}&channelName=${this.props.channel.displayName}`)
            .OnWindows(`msteams:/l/message/${this.props.channel.id}/${this.props.id}?tenantId=${this.props.tenant.id}&groupId=${this.props.team.id}&teamName=${this.props.team.displayName}&channelName=${this.props.channel.displayName}`)
            .Last()
        }
        target={
          new ConditionalOutput(`_blank`)
            .OnWindows(`_self`)
            .Last()
        }
        >
        <div
          className={styles.IA_teamsCard}
          style={{
            width: this.props.teamsStore.cardWidth,
            borderColor: this.props.teamsStore.borderColor != undefined ? this.props.teamsStore.borderColor : "transparent"
          }}
        >
          <div className={styles.IA_teamsCardHeader}>
            <div className={styles.IA_authorImageWrapper}>
              <div className={styles.IA_authorImageText}>
                {firstNameChar + lastNameChar}
              </div>
              <div
                className={styles.IA_authorImage}
                style={{
                  backgroundImage: `url('${this.props.author != undefined && this.props.author.id != undefined ? Helper.getProfileImageUrlFromImageAPI(Environment.getEnvironmentForImageAPI(this.props.teamsStore.environment), this.props.teamsStore.tenant, this.props.teamsStore.token, this.props.author.id.toString()) : undefined}')`
                }}
              />
            </div>
            <div className={styles.IA_authorName}>{this.props.author.displayName}</div>
            <div className={styles.IA_teamAndChannel}>{`${this.props.team.displayName} > ${this.props.channel.displayName}`}</div>
            <div className={styles.IA_date}>{this.dateTimeService.ConvertToDDMMYYYY(this.props.date)}</div>
          </div>
          {this.props.subject != undefined &&
            <div className={styles.IA_title}>{this.props.subject}</div>
          }
          <div 
          className={styles.IA_content} 
          style={{
            height: this.props.subject != undefined ? 160 : 195,
            paddingTop: this.props.subject != undefined ? 0 : 10
          }}
          dangerouslySetInnerHTML={{ __html: text != undefined ? text : "" }} 
          />
          {/* <div className={styles.IA_metaBar}>{commentAuthors}</div> */}
          <div className={styles.IA_commandBar}>
            <div>
              <IAIcon
                title={"Like"}
                size={14}
                color="#999999"
                style={{
                  float: "left"
                }}
              />
              <div style={{
                float: "left",
                marginLeft: 4
              }}>
                {this.props.reactions}
              </div>
              {/* <IAIcon
              title={"Comment"}
              size={14}
              color="#999999"
              style={{
                float: "left",
                marginLeft: 10
              }}
            />
            <div style={{
              float: "left",
              marginLeft: 4
            }}>
              {this.props.replies != undefined ? this.props.replies : 0}
            </div> */}
            </div>
          </div>
        </div>
      </a>
    )
  }
}
